module.exports = __webpack_public_path__ + "img/logo-icon-app.5dec838e.png";